let scheduleRouteModulePromise:
  | Promise<typeof import("@src/appV2/redesign/DailyView/DailyView")>
  | undefined;

export function loadScheduleRouteModule() {
  scheduleRouteModulePromise ??= import("@src/appV2/redesign/DailyView/DailyView").catch(
    (error: unknown) => {
      scheduleRouteModulePromise = undefined;
      throw error;
    }
  );

  return scheduleRouteModulePromise;
}

export function preloadScheduleRoute() {
  void loadScheduleRouteModule().catch(() => {
    // Ignore preload failures; real navigation path will retry.
  });
}
